import Alpine from "alpinejs";

let current = 0;
const HTML = document.documentElement;

const overflowClasses = (add) => {
    HTML.classList[add ? "add" : "remove"]("overflow-hidden");
    document.body.classList[add ? "add" : "remove"]("overflow-hidden");
};

HTML.style.setProperty("--header-height", "84px");

Alpine.data("header", () => ({
    mobileMenuOpen: false,
    dropdown: false,
    atTop: true,
    height: 0,
    jumboOpen: false,
    header: {
        ["@scroll.window.passive"]() {
            const offset = window.pageYOffset;
            this.atTop = offset < 150 || current > offset;
            current = offset;
            if (!this.height) {
                this.height = this.$refs.header.offsetHeight;
                HTML.style.setProperty("--header-height", `${this.height}px`);
            }
            if (!this.atTop) {
                overflowClasses(false);
                this.mobileMenuOpen = false;
                this.dropdown = false;
            }
        },
        [":class"]() {
            return this.atTop || "-translate-y-full";
        },
        ["@keydown.window.escape"]() {
            overflowClasses(false);
            this.mobileMenuOpen = false;
            this.dropdown = false;
        },
    },
    hamburger: {
        ["@click"]() {
            overflowClasses(true);
            this.mobileMenuOpen = true;
        },
    },
    times: {
        ["@click"]() {
            overflowClasses(false);
            this.mobileMenuOpen = false;
        },
    },
    mobileMenu: {
        ["x-transition"]() {
            return;
        },
        ["x-show"]() {
            return this.mobileMenuOpen;
        },
        ["x-trap"]() {
            return this.mobileMenuOpen;
        },
        ["@click.outside"]() {
            overflowClasses(false);
            this.mobileMenuOpen = false;
        },
    },
    dropdownClose: {
        ["@click"]() {
            this.dropdown = false;
            this.jumboOpen = false;
            overflowClasses(false);
        },
    },
    dropdownButton: (url, jumbo) => ({
        ["@click"]() {
            this.dropdown = this.dropdown == url ? false : url;
            if (jumbo && this.dropdown) {
                this.jumboOpen = true;
                overflowClasses(true);
            } else {
                this.jumboOpen = false;
                overflowClasses(false);
            }
        },
        [":class"]() {
            return this.dropdown == url ? "text-gray-900" : "text-gray-500";
        },
    }),
    dropdownChevron: (url) => {
        return {
            [":class"]() {
                return this.dropdown == url ? "text-gray-600 translate-y-3" : "text-gray-400";
            },
        };
    },
    dropdownElement: (url) => ({
        ["x-show"]() {
            return this.dropdown == url;
        },
        ["x-trap"]() {
            return this.dropdown == url;
        },
        ["@click.outside"]() {
            if (this.dropdown == url) {
                this.dropdown = false;
                this.jumboOpen = false;
                overflowClasses(false);
            }
        },
    }),
}));
